import {Inject, Injectable} from '@angular/core';
import {ParametersService} from "../parameters.service";
import {HttpClient} from "@angular/common/http";
import {
    GainsPoint,
    ICanvasJSChartOptions,
    StatisticsGainsData,
    StatisticsGainsResponse
} from "../../models";
import {SubtitlesService} from "../subtitles.service";
import {StatisticsService} from "./statistics.service";
import {DOCUMENT} from "@angular/common";

@Injectable({
    providedIn: 'root'
})
export class StatisticsGainsService {
    dataPoints: GainsPoint[] = [];

    constructor(
        private http: HttpClient,
        private parameters: ParametersService,
        private statistics: StatisticsService,
        private subtitles: SubtitlesService,
        @Inject(DOCUMENT) private document: Document
    ) { }

    getDynamicYieldsStatistics() {
        if (this.statistics.isDynamicYieldsGuard(this.statistics.state)) {
            const baseUrl = `/api/v1/modules/${this.parameters.selectedModuleHash}`;
            const objectId = this.statistics.state.objectId;
            const timePeriod = this.statistics.timePeriod;
            const url = `${baseUrl}/statistics/${objectId}/range/${timePeriod}`;

            this.http.get<StatisticsGainsResponse>(url).subscribe(response => {
                this.setChartObject(response.data, timePeriod);
            });
        }
    }

    private translateUnit(unit: string): string {
        if (this.statistics.isDynamicYieldsGuard(this.statistics.state)) {
            const responseUnit = parseInt(unit, 10);
            const subtitleId = Number.isNaN(responseUnit)
                ? this.statistics.state.unit
                : responseUnit;
            return this.subtitles.setSubtitle(subtitleId);
        }

        switch(unit){
            case '0':
                return 'W';
            case '1':
                return this.subtitles.setSubtitle(1908);
            case '2':
                return this.subtitles.setSubtitle(4212);
            case '3':
                return this.subtitles.setSubtitle(1909);
            case '4':
                return 'MJ';
            case '5':
                return 'GJ';
            case '6':
                return 'Gcal';
            default:
                return '';
        }
    }

    private getChartObject(response: StatisticsGainsData): ICanvasJSChartOptions {
        let chartColor = "#00C800";
        if(this.statistics.state === 'consumptions') chartColor = '#FF0205';
        this.dataPoints = response.dataPoints;


        return {
            animationEnabled: this.document.location.port !== '4200',
            theme: "dark1",
            backgroundColor: "#00000f",
            height: 600,
            axisX: {
                labelFontFamily: 'Roboto-Regular',
                labelFontSize: 14
            },
            axisY: {
                labelFontFamily: 'Roboto-Regular',
                labelFontSize: 14,
                title: this.translateUnit(response.unit)
            },
            toolTip: {
                enabled: true
            },
            data: [{
                color: chartColor,
                type: "column",
                dataPoints: response.dataPoints
            }]
        };
    }

    getYieldStatisticsData() {
        if (this.statistics.isYieldStateGuard(this.statistics.state)) {
            const timePeriod = this.statistics.timePeriod;
            const dataType = this.statistics.state;
            const baseUrl = `/api/v1/modules/${this.parameters.selectedModuleHash}`;
            const url = `${baseUrl}/statistics/${dataType}/range/${timePeriod}`;

            this.http.get<StatisticsGainsResponse>(url).subscribe(response => {
                this.setChartObject(response.data, timePeriod);
            });
        }
    }

    private setChartObject(responseData: StatisticsGainsData, timePeriod: string) {
        if (timePeriod === 'month') {
            responseData.dataPoints.forEach(x => {
                x.label = this.subtitles.setSubtitle(1009 + parseInt(x.label, 10));
            });
        } else if (timePeriod === 'total') {
            responseData.dataPoints[0].label = this.subtitles.setSubtitle(732);
        }

        if (responseData.dataPoints.length === 0) {
            this.statistics.messageContent = this.subtitles.setSubtitle(1240);
        } else {
            this.statistics.messageContent = '';
        }

        this.statistics.singleClick = false;
        const chartData = this.getChartObject(responseData)
        this.statistics.statisticsChartReady.next(this.statistics.applyChartMode(chartData));
    }
}
